
<template>
    <div class="config-selector">
        <semrush v-if="type == 'semrush_keyword_rank_branded_2' || type == 'semrush_keyword_rank_nonbranded_2'" :config="config" />
        <dataforseo v-if="type == 'dataforseo_branded' || type == 'dataforseo_nonbranded'" :config="config" />
        <uptime v-if="type == 'uptime' || type == 'uptime2'" :config="config" />
        <custom v-if="type == 'custom'" :config="config" />
        <sari v-if="type == 'sari'" :config="config" />
        <ofks v-if="type == 'ofks'" :config="config" />
        <primalgo v-if="type == 'primalgo'" :config="config" />
        <lsi v-if="type == 'lsi'" :config="config" />
        <cleverreach v-if="type == 'cleverreach'" :config="config" />
        <impaxis v-if="type == 'impaxis' || type.startsWith('impaxis.')" :config="config" />
    </div>
</template>

<script>
import Semrush from "./semrush/Semrush.vue";
import Dataforseo from "./dataforseo/Dataforseo.vue";
import Uptime from "./uptime/Uptime.vue";
import Sari from "./sari/Sari.vue";
import Ofks from "./ofks/Ofks.vue";
import Lsi from "./lsi/Lsi.vue";
import Primalgo from "./primalgo/Primalgo.vue";
import Custom from "./custom/Custom.vue";
import Cleverreach from "./cleverreach/Cleverreach.vue";
import Impaxis from "./impaxis/Impaxis.vue";

export default {
    props: ["type", "config"],
    components: {
        Semrush,
        Uptime,
        Custom,
        Sari,
        Ofks,
        Primalgo,
        Lsi,
        Cleverreach,
        Dataforseo,
        Impaxis
    }
}
</script>
